import { render } from "./GithubIcon.vue?vue&type=template&id=27f161f4&bindings={}"
import script from "./GithubIcon.vue?vue&type=script&lang=js"
export * from "./GithubIcon.vue?vue&type=script&lang=js"

import "./GithubIcon.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script